import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { TaskBoardAvatarComponent } from './task-board-avatar.component';

@NgModule({
  declarations: [
    TaskBoardAvatarComponent
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    TaskBoardAvatarComponent
  ]
})
export class TaskBoardAvatarModule { }
